/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';

import {StreamBankLink} from "../../StreamBankLink";
import {useFetchServiceModel} from "../../../../Hooks/ServiceHooks";
import {useFetchContextNode} from "../../../../Hooks/ContextHooks";
import {service as SurveyService} from "../../../../Services/SurveyService";

/**
 * "{SurveyType} survey" as a link into the survey, for the activity types that record a surveyId.
 *
 * The noun is inside the link rather than beside it, so an unresolved survey degrades to the bare
 * word "survey" and the sentence still reads — the component this replaces put the noun outside and
 * fell back to the same word inside, which rendered "the survey survey".
 *
 * Degrading is a deliberate change from that component, which returned "Loading..." and then an
 * error message for the whole description. The sentence's subject is the answers that changed, not
 * the survey, so it is worth reading before the survey resolves and worth reading if it never does;
 * the link is an affordance on top.
 */
export const SurveyLink = props => {
    const {SurveyId, ContextNodeId, Event} = props;

    const contextNode = useFetchContextNode(ContextNodeId, Event?.ContextNodeDetails ?? null);
    const survey = useFetchServiceModel(SurveyService, SurveyId);
    const surveyType = survey?.SurveyType;

    if (!surveyType?.name) {
        return 'survey';
    }

    return <StreamBankLink Context={contextNode?.link} Tool={surveyType.code}>
        {surveyType.name} survey
    </StreamBankLink>;
};
